<template>
  <main>
    <section class="page-inner-header">
      <div class="container">
      <div class="top-logos">
        <div class="top-logo top-logo-right">
          <router-link to="/">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 323.19 109.18">
              <g id="katman_2" data-name="katman 2">
                <g id="katman_1-2" data-name="katman 1">
                  <path d="M323.19,109.06c-.76,0-1.53.12-2.29.12H216.45c-2.64,0-2.64,0-2.64-2.55V.08H320.7c.83,0,1.66,0,2.49-.08ZM312.85,98.79V96.62q0-42,0-84c0-1.79-.41-2.37-2.3-2.37q-42.15.09-84.31.05c-.68,0-1.35.06-2,.09V98.79Z" />
                  <path d="M123.85,89.07V20.85a13,13,0,0,1,1.47-.17c9.07,0,18.14-.12,27.2.09,5.56.14,10.7,1.71,14.44,6.28,7,8.55,4.84,20.48-4.72,25.85-.44.24-.87.51-1.42.84.27.21.43.44.63.49,7.7,2.06,10.49,9.38,10.5,15.58,0,9.85-6,17.24-15.38,19.09a17.53,17.53,0,0,1-3.4.27c-9.28,0-18.55,0-27.83,0C124.91,89.19,124.48,89.12,123.85,89.07Zm10.36-9.64a7.54,7.54,0,0,0,1,.14c5.68-.08,11.36-.12,17-.26,6.12-.14,9.46-5.6,9.39-10.32-.09-5.73-3.77-9.79-9.62-10.06-5.61-.26-11.24-.15-16.86-.19a5,5,0,0,0-1,.17Zm0-49.26V49.59c4.61,0,9.06,0,13.52,0a31.69,31.69,0,0,0,5.51-.47c4.27-.81,7.41-5.06,7.33-9.68s-3.27-8.91-7.58-9.16C146.82,29.9,140.58,30.17,134.25,30.17Z" />
                  <path d="M108.52,70.37c-.33,5.08-3.13,9.21-6.71,12.66A24.27,24.27,0,0,1,77,88.43c-11.5-4.05-16.21-11.37-16.78-20.14a164.26,164.26,0,0,1,.27-28.83,19.72,19.72,0,0,1,5-10.94A25.33,25.33,0,0,1,96,22.69c7.56,3.8,12.36,10,12.76,18.83.21,4.45.37,8.94.37,13.4C109.1,59.91,108.85,65.22,108.52,70.37Zm-10-25.73c-.29-9.27-6.84-14-13.24-14.31C78.33,30,71.32,35.1,70.94,41.85c-.43,7.61-.63,15.27-.36,22.88.34,9,4.87,13.88,12.92,14.73A13.45,13.45,0,0,0,98.18,67.52C98.57,63.35,98.61,48.07,98.5,44.64Z" />
                  <path d="M53.39,89.19c-4,0-7.66.07-11.29-.07-.59,0-1.34-.82-1.7-1.44Q32,72.79,23.66,57.83c-.37-.66-.77-1.31-1.23-2.1a15,15,0,0,0-1.19,1c-3.32,3.46-6.68,6.89-9.9,10.43A4.22,4.22,0,0,0,10.23,70c-.11,5.61-.06,11.22-.06,16.83V89H0V20.67c2.84,0,5.57,0,8.31,0,.55,0,1.11.08,1.85.13V55.63l.39.18c.43-.5.87-1,1.28-1.49Q24.82,38.18,37.77,22a3.64,3.64,0,0,1,3-1.37c3.25.09,6.51,0,10.24,0-.63.83-1,1.4-1.48,1.95C43.1,30.48,36.7,38.35,30.23,46.16A2.3,2.3,0,0,0,30,49.3C37.43,61.85,44.8,74.45,52.2,87,52.54,87.63,52.86,88.24,53.39,89.19Z" />
                  <rect x="186.76" y="40.74" width="10.05" height="48.39" />
                  <rect x="186.7" y="20.81" width="10.17" height="10.04" />
                  <path d="M280.44,27.16l-5.66,8.36a32.69,32.69,0,0,0-16.17-5.12c-4.31-.12-8.26.66-11,4.54a8.33,8.33,0,0,0,2.51,12.13c3.15,2,6.78,2.07,10.27,2.75,3.8.74,7.78,1.2,11.28,2.7,8.76,3.72,12.85,13.94,9.86,23.88-2.11,7-7.09,10.79-13.87,12.28-11.4,2.51-22.19.84-32.09-5.55-1.17-.75-2.24-1.65-3.53-2.61l6.73-7.7a31.9,31.9,0,0,0,14.23,6.25c4.39.67,8.79.76,13.05-.76a8.86,8.86,0,0,0,6.13-9.12,8.31,8.31,0,0,0-6.57-7.95c-3.77-.9-7.66-1.31-11.5-2-6.45-1.08-12-3.52-15.73-9.36-5.6-8.8-3-25.16,11.72-28.79,10.39-2.56,20.11-.37,29.16,5.14A12.71,12.71,0,0,1,280.44,27.16Z" />
                  <rect x="292.83" y="40.67" width="9.51" height="48.4" />
                  <path d="M302.33,30.47c-2.95,0-5.75,0-8.55,0a1.45,1.45,0,0,1-1.06-.94c-.08-2.85,0-5.7,0-8.69h9.65Z" />
                </g>
              </g>
            </svg>
          </router-link>
        </div>
      </div>
      <div>
        <div class="paralax-item shape-dotes">
          <div class="paralax-item-inner top speed-20">
            <svg class="shape">
              <use xlink:href="../../assets/images/icon/shape-sprite.svg#dotes" />
            </svg>
          </div>
        </div>
        <div class="paralax-item shape-triangle triangle1">
          <div class="paralax-item-inner spinBackwards bottom speed-20">
            <svg class="shape">
              <use xlink:href="../../assets/images/icon/shape-sprite.svg#triangle" />
            </svg>
          </div>
        </div>
        <div class="paralax-item shape-zigzag">
          <div class="paralax-item-inner spin speed-1">
            <svg class="shape">
              <use xlink:href="../../assets/images/icon/shape-sprite.svg#zigzag" />
            </svg>
          </div>
        </div>
      </div>

      <div class="d-flex content content-main">
        <div class="descSide">
          <div class="page-title" v-if="pageData">
            <p class="simple" v-html="pageData.description"></p>
            <h1>{{ pageData.inputSide.title }}</h1>
            <a href="#prices-section" class="prices-cta" @click.prevent="scrollToPrices">
              {{ pageData.inputSide.description }}
            </a>
          </div>
        </div>

        <div class="formSide">
          <form action="https://admin.kobisi.com/e-ticaret-ucretsiz-deneme-surumu" target="_self" id="register-form" @submit="syncEntrySource">
            <div class="formDiv">
              <div class="f-row vert">
                <label><span>{{ generalData.form.placeholder.name }}</span></label>
                <input type="text" name="user-name" :placeholder="generalData.form.placeholder.name" v-model="userName" />
              </div>
              <div class="f-row vert no-spinner">
                <label><span>{{ generalData.form.placeholder.phone }}</span></label>
                <input type="number" name="user-tel" :placeholder="generalData.form.placeholder.phone" v-model="userTel" />
              </div>
              <div class="f-row vert">
                <label><span>{{ generalData.form.placeholder.email }}</span></label>
                <input type="email" name="user-email" :placeholder="generalData.form.placeholder.email" v-model="userEmail" />
              </div>
              <div class="f-row vert">
                <label><span>{{ generalData.form.placeholder.store }}</span></label>
                <input type="text" name="store-name" :placeholder="generalData.form.placeholder.store" v-model="storeName" />
              </div>
              <div class="f-row vert">
                <label><span>Referans (İndirim) Kodu</span></label>
                <input type="text" name="referans-kodu" placeholder="Referans (İndirim) Kodu" v-model="referansCode" />
              </div>
              <input type="hidden" name="entry_source" v-model="entrySource" />
              <input type="hidden" name="selected_package" v-model="selectedPackage" />
              <input type="hidden" name="landing_link_source" v-model="landingLinkSource" />
              <input type="hidden" name="landing_link_url" v-model="landingLinkUrl" />
              <input type="hidden" name="location" v-model="locationParam" />
              <input v-if="pParam" type="hidden" name="P" v-model="pParam" />
              <div class="f-row">
                <button type="submit" class="primary radiused big full-w">{{ generalData.form.button }}</button>
              </div>

              <span class="termsOfUse" v-if="pageData" v-html="pageData.inputSide.termsOfUse"></span>
              <br />
              <span class="termsOfUse" v-html="generalData.form.information"></span>
            </div>
          </form>
        </div>
      </div>
      </div>
    </section>

    <section id="prices-section" class="aydem-prices-header" v-if="pricesContent" ref="pricesSection">
      <div class="container">
        <div class="page-title">
          <h1>{{ pricesContent.title }}</h1>
          <h2>{{ pricesContent.text }}</h2>
        </div>
      </div>
    </section>

    <section class="packages-cards aydem-packages">
      <div class="container">
        <div class="tab-navigation">
          <ul>
            <li @click="packageType('annual')" :class="activePackage === 'annual' ? 'active' : ''">
              {{ generalData.pricesPage.packeageTypeAnnualTab }}
            </li>
            <li @click="packageType('monthly')" :class="activePackage === 'monthly' ? 'active' : ''">
              {{ generalData.pricesPage.packeageTypeMonthlyTab }}
            </li>
          </ul>
        </div>

        <div class="aydem-cards-wrapper">
          <div class="aydem-card" v-for="packageItem in filteredPackages" :key="packageItem.id">
            <div class="inner-wrap">
              <div class="package-name">{{ packageItem.name }}</div>

              <div class="package-prices">
                <div class="normal-price" v-if="packageItem.price">
                  {{ activePackage === 'annual' ? packageItem.price.annual : packageItem.price.monthly }}
                  <div class="packae-type" v-if="packageItem.type === 'monthly'">
                    / {{ generalData.pricesPage.packeageTypeMonthly }}
                  </div>
                </div>
                <div class="price-row" v-if="activePackage === 'annual'">
                  <div class="discounted-price" v-if="packageItem.discounted_price">
                    {{ packageItem.discounted_price.annual }}
                  </div>
                  <div class="discounted-prices" v-if="packageItem.price">
                    {{ packageItem.price.realPrice }}
                  </div>
                </div>
              </div>

              <div class="aydem-discount-badge" v-if="activePackage === 'annual'">
                🏷️ Aydem Plus'a Özel <strong>{{ discountedPrice(packageItem) }}</strong>
              </div>

              <div class="sepesific-feature-list">
                <div class="sepesific-feature-list-item" v-for="specificFeaturesItem in packageItem.specificFeatures" :key="specificFeaturesItem">
                  <svg class="shape">
                    <use xlink:href="../../assets/images/icon/icon-sprite.svg#checkmark" />
                  </svg>
                  <span>
                    {{ specificFeaturesItem }}
                    <span class="free-badge" v-if="specificFeaturesItem === 'Trendyol Entegrasyonu'">Ücretsiz</span>
                  </span>
                </div>
              </div>

              <button class="bttn primary radiused outline" @click="markBuySource(packageItem)">
                Satın al
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <faqSections :lang="lang" :title="'pages.prices.faq'" general="general" />
    <aydemPopup />
  </main>
</template>

<script>
import tr from "@/lang/tr.js";
import en from "@/lang/en.js";
import faqSections from "@/components/faqSection/faqSection.vue";
import aydemPopup from "@/components/aydemPopup/AydemPopup.vue";

export default {
  name: "AydemTestView",
  mixins: [tr, en],
  components: {
    faqSections,
    aydemPopup,
  },
  props: {
    lang: String,
    general: String,
  },
  data() {
    return {
      userName: "",
      userEmail: "",
      userTel: "",
      storeName: "",
      referansCode: "",
      entrySource: "direct_form",
      selectedPackage: "",
      landingLinkSource: "",
      landingLinkUrl: "",
      locationParam: "",
      pParam: "",
      activePackage: "annual",
    };
  },
  computed: {
    currentLang() {
      return this.lang === "en" ? "en" : "tr";
    },
    langData() {
      return this[this.currentLang] || this.tr || {};
    },
    generalData() {
      return this.langData.general || {
        form: {
          placeholder: { name: "", phone: "", email: "", store: "" },
          button: "",
          information: "",
        },
        pricesPage: {
          packeageTypeAnnualTab: "",
          packeageTypeMonthlyTab: "",
          packeageTypeMonthly: "",
          packageRegister: "",
        },
      };
    },
    pageData() {
      return this.langData && this.langData.pages
        ? this.langData.pages.aydem
        : null;
    },
    pricesContent() {
      return this.pageData && this.pageData.prices ? this.pageData.prices : null;
    },
    filteredPackages() {
      const pages = this.langData && this.langData.pages
        ? this.langData.pages
        : null;
      const packages = pages && pages.prices && Array.isArray(pages.prices.packages)
        ? pages.prices.packages
        : [];
      return packages.filter((p) => p && (p.name === "Personal" || p.name === "Professional"));
    },
  },
  methods: {
    packageType(type) {
      this.activePackage = type;
    },
    markBuySource(packageItem) {
      this.entrySource = "buy_button";
      this.selectedPackage = packageItem && packageItem.name ? packageItem.name : "";
      this.scrollToTop();
    },
    syncEntrySource() {
      this.entrySource = this.entrySource || "direct_form";
      this.selectedPackage = this.selectedPackage || "";
    },
    scrollToPrices() {
      const target = this.$refs.pricesSection;
      if (target && typeof target.scrollIntoView === "function") {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    syncFaqDescription() {
      const faqTextEl = document.querySelector(".faq-section .section-title p");
      if (!faqTextEl) return;
      faqTextEl.textContent =
        "Merak ettiğiniz konular için Sıkca Sorulan Sorular bölümünü inceleyebilir veya beni ara butonuna tıklayarak bizimle iletişime geçebilirsiniz.";
    },
    discountedPrice(packageItem) {
      const priceStr = packageItem.price && packageItem.price.realPrice;
      if (!priceStr) return "";
      const numeric = parseFloat(priceStr.replace(/\./g, "").replace(",", ".").replace("₺", ""));
      if (isNaN(numeric)) return priceStr;
      const discounted = Math.round(numeric * 0.85);
      return discounted.toLocaleString("tr-TR") + "₺";
    },
  },
  mounted() {
    document.body.classList.add("active-page", "aydem-test-page");
    this.entrySource = "direct_form";
    this.selectedPackage = "";
    this.landingLinkUrl = window.location.href;
    this.landingLinkSource = window.location.pathname === "/aydem-test" ? "aydem" : "";
    this.locationParam = new URLSearchParams(window.location.search).get("location") || "";
    this.pParam = new URLSearchParams(window.location.search).get("P") || "";
    this.$nextTick(() => {
      this.syncFaqDescription();
    });
  },
  updated() {
    this.syncFaqDescription();
  },
  destroyed() {
    document.body.classList.remove("active-page", "aydem-test-page");
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

.container {
  max-width: 1200px;
}

.page-inner-header {
  padding: 0;
  background: $gray;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 1200px) {
    padding: 4.5em 0 2.2em;
  }

  @media screen and (min-width: 1201px) {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &:after {
      content: "";
      width: 50%;
      background-color: $white;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    header {
      display: none;
    }
  }

  .page-title {
    position: relative;
    align-self: center;
    z-index: 3;

    h1 {
      font-size: 2.4em;
      font-weight: 700;
      margin-bottom: 0.4em;
      margin-top: 0.5em;
    }

    .lead {
      font-size: 1.5em;
      margin-bottom: 1em;
    }

    .simple {
      font-size: 1.3em;
      font-weight: 100;
    }

    .prices-cta {
      border: 0;
      background: transparent;
      padding: 0;
      margin-top: 0.6em;
      text-align: left;
      color: $text-color;
      font-size: 1.2em;
      font-weight: 400;
      text-decoration: none;
      cursor: pointer;
      display: inline-block;
    }

    @media screen and (max-width: 1200px) {
      text-align: center;
    }
  }

  .paralax-item {
    z-index: 1;
  }

  .shape-dotes {
    inset-inline-start: 20px;
    top: 20%;
    bottom: 10%;
    width: 400px;
    height: 400px;
    fill: darken($color: $gray, $amount: 4%);

    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .shape-zigzag {
    inset-inline-start: 3%;
    bottom: 40%;
    width: 90px;
    height: 90px;
    fill: darken($color: $gray, $amount: 40%);

    @media screen and (max-width: 1200px) {
      bottom: auto;
      top: 20%;
      inset-inline-start: unset;
      inset-inline-end: 10%;
      fill: $gray;
    }
  }

  .shape-triangle {
    inset-inline-end: 10%;
    width: 120px;
    height: 120px;
    fill: $white;

    &.triangle1 {
      bottom: 60%;

      @media screen and (max-width: 1200px) {
        inset-inline-end: 5%;
        bottom: 15%;
      }
    }
  }

  * {
    color: $text-color;
  }
}

.top-logos {
  position: absolute;
  top: 24px;
  left: 0;
  width: 100%;
  z-index: 4;
  min-height: 56px;
}

.top-logo {
  position: absolute;
  top: 0;

  img {
    height: 52px;
    width: auto;
    display: block;
  }

  svg {
    width: 148px;
    fill: darken($color: $primary-color, $amount: 40%);
  }
}

.top-logo-right {
  right: 24px;
}

.content {
  justify-content: space-between;
  align-items: flex-start;
  position: relative;

  @media screen and (max-width: 1200px) {
    flex-direction: column-reverse;
    align-items: center;
    max-width: 90%;
    margin: 0 auto;

    h2,
    h1,
    p {
      text-align: center;
    }
  }

  .descSide {
    max-width: 450px;
    position: relative;
    z-index: 2;

    .logo {
      margin-bottom: 5.4em;
      margin-top: 1em;

      @media screen and (max-width: 1200px) {
        display: none;
      }

      svg {
        width: 200px;
        fill: darken($color: $primary-color, $amount: 40%);
      }
    }
  }

  .formSide {
    position: relative;
    z-index: 2;
    max-width: 500px;

    input {
      border: 1px solid darken($color: $gray, $amount: 10%);
    }

    @media screen and (max-width: 1200px) {
      margin-bottom: 5em;
    }

    .formDiv {
      flex-direction: column;

      :nth-child(4) {
        margin-bottom: 2em;
      }

      > div {
        width: 100%;
      }
    }
  }
}

.content-main {
  margin-top: 140px;
}

.termsOfUse {
  margin-top: 1rem;
  font-size: 0.8em;

  a {
    font-weight: 900 !important;
  }
}

@media screen and (max-width: 991px) {
  .top-logos {
    position: static;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0.8em;
    margin-bottom: 0.5em;
  }

  .top-logo {
    position: static;
  }

  .top-logo-right {
    order: 1;
    right: auto;

    svg {
      width: 132px;
    }
  }

  .content-main {
    margin-top: 16px;
  }
}

.aydem-prices-header {
  padding: 10em 0 15em;
  background: darken($color: $primary-color, $amount: 45%);
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 991px) {
    padding: 4.5em 0 2.4em;
  }

  .page-title {
    max-width: 850px;
    margin: 0 auto 1em;
    text-align: center;
    z-index: 3;
    position: relative;

    * {
      color: $white !important;
    }

    h1 {
      font-size: 2.3em;
      font-weight: 700;
    }

    h2 {
      font-size: 1.6em;
      font-weight: 100;
      margin-bottom: 1em;
      margin-top: 1em;
    }
  }
}

.aydem-packages {
  padding-top: 0;
  margin-top: -6em;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 991px) {
    margin-top: 0;
  }

  .tab-navigation {
    position: absolute;
    left: 0;
    bottom: 109%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    @media screen and (max-width: 991px) {
      position: relative;
      bottom: unset;
      margin-top: 1em;
      margin-bottom: 1em;
    }

    ul {
      background-color: rgba($color: $white, $alpha: 0.7);
      display: inline-flex;
      align-items: center;
      border-radius: 4em;

      li {
        padding: 0.6em 1.4em;
        list-style: none;
        font-weight: 700;
        border-radius: 4em;
        min-width: 100px;
        transition: background-color 0.2s ease-in-out;
        text-align: center;
        cursor: pointer;

        &.active {
          background-color: $white;
        }
      }
    }
  }
}

.aydem-cards-wrapper {
  display: flex;
  justify-content: center;
  gap: 30px;
  padding: 3em 0 4em;
  align-items: stretch;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}

.aydem-card {
  width: 300px;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 340px;
  }

  .inner-wrap {
    border: 1px solid darken($color: $gray, $amount: 40%);
    background-color: $white;
    padding: 1.4em;
    padding-top: 2em;
    border-radius: 1em;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .package-name {
      font-size: 1.6em;
      font-weight: 700;
      width: 100%;
      margin-bottom: 1.4em;
    }

    .package-prices {
      margin-bottom: 1.8em;

      .normal-price {
        font-size: 2.4em;
        font-weight: 900;
        line-height: 1.1;
        display: flex;
        align-items: baseline;

        .packae-type {
          font-weight: normal;
          font-size: 0.4em;
          margin-inline-start: 0.4em;
        }
      }

      .price-row {
        display: flex;
        align-items: baseline;
        gap: 0.5em;
        flex-wrap: wrap;
        margin-top: 0.4em;

        .discounted-price {
          position: relative;
          font-size: 1em;
          opacity: 0.6;

          &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-10deg);
            width: 100%;
            height: 1px;
            background-color: $text-color;
          }
        }

        .discounted-prices {
          font-size: 1.1em;
          line-height: 1.1;
          opacity: 0.7;
        }
      }
    }

    .aydem-discount-badge {
      background-color: lighten($color: $primary-color, $amount: 45%);
      color: darken($color: $primary-color, $amount: 10%);
      border: 1px solid lighten($color: $primary-color, $amount: 30%);
      border-radius: 6px;
      padding: 6px 10px;
      font-size: 12px;
      font-weight: 700;
      margin-bottom: 12px;
      text-align: start;
      width: 100%;
    }

    .sepesific-feature-list {
      flex: 1;
      margin-bottom: 1em;
      width: 100%;

      .sepesific-feature-list-item {
        font-size: 0.85em;
        margin-bottom: 0.5em;
        display: flex;
        justify-content: flex-start;
        text-align: start;

        svg {
          width: 18px;
          height: 18px;
          margin-top: 0.1em;
          margin-inline-end: 0.4em;
          fill: $primary-color;
          flex-shrink: 0;
        }
      }
    }

    .free-badge {
      background-color: $primary-color;
      padding: 2px 4px;
      border-radius: 5px;
      color: $white;
      font-size: 11px;
      margin-inline-start: 4px;
    }

    .bttn {
      width: 100%;
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
body.aydem-test-page #header {
  display: none !important;
}

body.aydem-test-page footer {
  display: block !important;
}
</style>
